"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_16_0_0 = void 0;
/**
 * Migrate to 16.0.0
 *
 * The Konfektionierung has been removed in favor of an array. We migrate that to the new
 * CustomKonfektionierungPrice.
 *
 *  konfektionierung: Konfektionierung
 *
 *  =>
 *
 *  customKonfektionierungPrice: CountryPrice
 */
const migration_16_0_0 = (json) => {
    if (json.Konfektionierung) {
        json.CustomKonfektionierungPrice = json.Konfektionierung.Preis;
        delete json.Konfektionierung;
    }
    return json;
};
exports.migration_16_0_0 = migration_16_0_0;
//# sourceMappingURL=migration_16_0_0.js.map